<!-- FILTER BAR -->
<section class="filtering">
  <div class="left">
    <h2>All {{ canvasType }}s</h2>
  </div>

  <div class="center">
    <span class="error" *ngIf="error">{{ error }}</span>
    <span class="error" *ngIf="!error">&nbsp;</span>
    <div class="searchBox">
      <form [formGroup]="canvasForm">
        <mat-form-field
          style="width: 40%"
          class="searchSelect"
          appearance="outline"
        >
          <mat-select
            formControlName="category"
            aria-label="Choose the category"
            (selectionChange)="searchCanvasItems()"
          >
            <mat-option value="" role="option" aria-role="option">
              All Categories
            </mat-option>
            <mat-option
              role="option"
              aria-role="option"
              *ngFor="let category of categories"
              [value]="category.id"
            >
              {{ category.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        &nbsp;
        <mat-form-field style="width: 50%" class="search" appearance="outline">
          <input
            matInput
            placeholder="Search {{ canvasType }}s"
            formControlName="searchTerm"
            name="Search"
            (keyup.enter)="searchCanvasItems()"
            aria-label="Search"
          />
        </mat-form-field>

        <fa-icon
          [icon]="faSearch"
          matSuffix
          mat-button
          class="searchIcon"
        ></fa-icon>
      </form>
    </div>
  </div>
  <div class="right">
    <fa-icon
      [icon]="faArrowDownAZ"
      class="reports_view"
      (click)="changeSort($event)"
      *ngIf="!direction"
    ></fa-icon>
    <fa-icon
      [icon]="faArrowUpZA"
      class="reports_view"
      (click)="changeSort($event)"
      *ngIf="direction"
    ></fa-icon>
    <fa-icon
      [icon]="faList"
      class="reports_view"
      (click)="displayList('list', $event)"
    ></fa-icon>
    <fa-icon
      [icon]="faGrid"
      class="reports_view active"
      (click)="displayList('grid', $event)"
    ></fa-icon>
  </div>
</section>

<ng-container
  *ngIf="canvas_listing && canvas_listing.length <= 0 && canvasListLoaded"
>
  <div class="noItems">No {{ canvasType }}s available to be shown</div>
</ng-container>

<ng-container
  *ngIf="canvas_listing && canvas_listing.length <= 0 && !canvasListLoaded"
>
  <div class="loading-spinner">
    <mat-spinner strokeWidth="3" diameter="50"></mat-spinner>
    Loading All {{ canvasType }}s
  </div>
</ng-container>
<ng-container *ngIf="canvas_listing && canvas_listing.length > 0">
  <!-- REPORTS BAR -->
  <section class="reports">
    <ng-container *ngIf="display_data == 'grid'">
      <mat-grid-list [cols]="breakpoint" rowHeight="325px" gutterSize="10">
        <mat-grid-tile
          *ngFor="
            let item of canvas_listing
              | paginate
                : {
                    itemsPerPage: 12,
                    currentPage: page,
                    totalItems: totalCanvasObjectResults
                  };
            let i = index
          "
        >
          <app-canvas-tile
            [id]="item.id"
            type="tile"
            [favorited]="item.isFavorite"
            [editable]="(!item.isSystem && item.hasEdit) || false"
            [isSystem]="item.isSystem || false"
            [category]="item.category"
            [category_id]="item.category_id"
            [title]="item.name"
            [description]="item.description"
            [author]="item.owner"
            [updated]="item.updated_at"
            style="width: 100%"
            [canvasType]="canvasType"
          >
          </app-canvas-tile>
        </mat-grid-tile>
      </mat-grid-list>
    </ng-container>

    <ng-container *ngIf="display_data == 'list'">
      <div class="tile_list_header">
        <span class="image"></span>
        <span class="title">Title</span>
        <span class="type">Category</span>
        <span class="createdBy">Created By</span>
        <span class="modified">Last Modified</span>
        <span class="actions">Actions</span>
      </div>

      <mat-grid-list [cols]="1" rowHeight="65px" gutterSize="5">
        <mat-grid-tile
          *ngFor="
            let item of canvas_listing
              | paginate
                : {
                    itemsPerPage: 12,
                    currentPage: page,
                    totalItems: totalCanvasObjectResults
                  };
            let i = index
          "
        >
          <app-canvas-tile
            [id]="item.id"
            type="tile_list"
            [favorited]="item.isFavorite"
            [editable]="(!item.isSystem && item.hasEdit) || false"
            [isSystem]="item.isSystem || false"
            [category]="item.category"
            [category_id]="item.category_id"
            [title]="item.name"
            [description]="item.description"
            [author]="item.owner"
            [updated]="item.updated_at"
            style="width: 100%"
            [canvasType]="canvasType"
          >
          </app-canvas-tile>
        </mat-grid-tile>
      </mat-grid-list>
    </ng-container>
  </section>

  <section class="pagination">
    <pagination-controls
      (pageChange)="handlePageChange($event)"
      previousLabel=""
      nextLabel=""
    ></pagination-controls>
  </section>
</ng-container>
